const includesAllFilters = (filters, selectedFilters) => {
    return selectedFilters.every(selectedFilter => filters.includes(selectedFilter));
};

const includesAtLeastOneFilter = (filters, selectedFilters) => {
    return selectedFilters.some(selectedFilter => filters.includes(selectedFilter));
};

const containsAtLeastOne = (allResults, selectedFilters) => {
    return allResults.filter(result => {
        return includesAtLeastOneFilter(result.filters, selectedFilters);
    });
};

const containsAll = (allResults, selectedFilters) => {
    return allResults.filter(result => {
        return includesAllFilters(result.filters, selectedFilters);
    });
};

const sorted = (allResults, selectedFilters) => {
    const unsortedResults = allResults.filter(result => {
        return includesAtLeastOneFilter(result.filters, selectedFilters);
    });

    return unsortedResults.sort((a, b) =>
        selectedFilters.indexOf(a.filters[0]) < selectedFilters.indexOf(b.filters[0]) ? -1 : 1
    );
};

const correctAnswerThreshold = (allResults, selectedFilters, prompts) => {
    /* Note: This strategy was designed for a single-choice question with multiple possible correct answers.
        In the future we may want to allow for multiple sub-types of scoring here. For instnace, a 
        question where the user must select ALL correct answers, or one where they need to select
        ONLY correct answers, etc.
    */
    let correctCount = 0;

    Object.values(prompts).forEach(prompt => {
        if (prompt?.correctAnswer.some(answerChoice => selectedFilters.indexOf(answerChoice) > -1)) {
            correctCount += 1;
        }
    })

    const sortedResults = [...allResults].sort((a, b) => a.threshold > b.threshold ? -1 : 1);

    const result = sortedResults.find(res => correctCount >= res.threshold);

    return result ? [result] : [];
};

export const getFilterStrategy = resultsConfig => {
    const strategies = {
        containsAtLeastOne,
        containsAll,
        sorted,
        correctAnswerThreshold
    };

    const { filterStrategy } = resultsConfig;

    if (!strategies[filterStrategy]) {
        return containsAll;
    }

    return strategies[filterStrategy];
};
